import TeamsPageNameCell from 'pages/Teams/Cells/NameCell';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function TeamNameCell({ rowData }: CellProps) {
  return <TeamsPageNameCell hideLogo rowData={rowData} />;
}
